'use client';

import React, { useEffect } from 'react';
import { useRouter } from 'next/navigation';
import { getToken } from '@/services/_utils';
import { goToLoginPage } from '@/_utils';
import { isMobileDevice } from '@/utils/device';

const AppPage = () => {
  const router = useRouter();

  useEffect(() => {
    const token = getToken();
    if (token) {
      router.push(isMobileDevice() ? `/chat` : `/home`);
    } else {
      goToLoginPage({ returnUrl: true });
    }
  }, []);

  return <></>;
};

export default AppPage;
